import pickBy from 'lodash/pickBy';
import isArray from 'lodash/isArray';
import concat from 'lodash/concat';
import join from 'lodash/join';
import map from 'lodash/map';
import toPairs from 'lodash/toPairs';
import compact from 'lodash/compact';

import {
  GET_APPENDED_RESULTS,
  RESET_GET_APPENDED_RESULTS,
} from '../constants/ActionTypes';

export function getAppendedResultsQuery(path, options, subrequest, append) {
  let queryArray = [];
  options = pickBy(
    options,
    (value) => value !== undefined && value !== null && value !== '',
  );
  const arrayOptions = pickBy(options, (item) => isArray(item));

  queryArray = concat(
    queryArray,
    options
      ? join(
          map(toPairs(pickBy(options, (item) => !isArray(item))), (item) => {
            if (item[0] === 'SearchableText') {
              // Adds the wildcard to the SearchableText param
              item[1] = `${item[1]}*`;
            }
            return join(item, '=');
          }),
          '&',
        )
      : '',
  );

  queryArray = concat(
    queryArray,
    arrayOptions
      ? join(
          map(pickBy(arrayOptions), (item, key) =>
            join(
              item.map(
                (value) =>
                  `${encodeURIComponent(key)}:list=${encodeURIComponent(value)}`,
              ),
              '&',
            ),
          ),
          '&',
        )
      : '',
  );
  const querystring = join(compact(queryArray), '&');

  return {
    type: GET_APPENDED_RESULTS,
    subrequest,
    request: {
      op: 'get',
      path: `${path}/@search${querystring ? `?${querystring}` : ''}`,
    },
    appendResults: append || false,
  };
}

export function resetGetAppendedResults(subrequest = null) {
  return {
    type: RESET_GET_APPENDED_RESULTS,
    subrequest,
  };
}
